// "Choose a new password" popup — the second half of Forgot password.
//
// The reset email's link opens the game with a one-time recovery session
// (URL contains type=recovery, and supabase-js fires PASSWORD_RECOVERY). Without
// this screen the player would just land signed-in and never get to set a new
// password. Reuses the Log in popup's look (.login-modal*).

import { supabase } from '../game/supabase.js'
import { setActivePage } from './siteRouter.js'

// Read the URL NOW, synchronously at import time: supabase-js strips the token
// from the address bar a moment after it starts up.
const cameFromRecoveryLink =
  typeof location !== 'undefined' && /(^|[#&?])type=recovery\b/.test(location.hash + location.search)

export function mountResetPasswordModal() {
  if (document.querySelector('.login-modal--reset')) return // idempotent

  const wrap = document.createElement('div')
  wrap.className = 'login-modal login-modal--reset'
  wrap.innerHTML = `
    <div class="login-modal__backdrop"></div>
    <div class="login-modal__card" role="dialog" aria-modal="true" aria-label="Choose a new password">
      <button class="login-modal__x" data-reset-close aria-label="Close">×</button>
      <h2 class="login-modal__title">New password</h2>
      <p class="login-modal__sub">Choose a new password for your kingdom.</p>
      <form data-reset-form>
        <input class="login-modal__input" type="password" name="password" placeholder="New password (6+ characters)" autocomplete="new-password" minlength="6" required>
        <input class="login-modal__input" type="password" name="confirm" placeholder="Repeat new password" autocomplete="new-password" minlength="6" required>
        <div class="login-modal__msg" data-reset-msg></div>
        <button class="login-modal__submit" type="submit" data-reset-submit>Save new password</button>
      </form>
    </div>
  `
  document.body.appendChild(wrap)

  const form = wrap.querySelector('[data-reset-form]')
  const msg = wrap.querySelector('[data-reset-msg]')
  const submit = wrap.querySelector('[data-reset-submit]')
  const setMsg = (t, ok = false) => { msg.textContent = t; msg.classList.toggle('ok', ok) }

  const open = () => {
    setMsg('')
    wrap.classList.add('open')
    form.querySelector('[name=password]').focus()
    // Tidy the address bar so a refresh doesn't re-open this.
    try { history.replaceState(null, '', location.pathname) } catch { /* ignore */ }
  }
  const close = () => wrap.classList.remove('open')
  wrap.querySelector('[data-reset-close]').addEventListener('click', close)
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && wrap.classList.contains('open')) close() })

  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    const password = form.password.value
    if (password.length < 6) { setMsg('Use at least 6 characters.'); return }
    if (password !== form.confirm.value) { setMsg('The two passwords don’t match.'); return }
    submit.disabled = true
    setMsg('Saving…')
    const { error } = await supabase.auth.updateUser({ password })
    submit.disabled = false
    if (error) { setMsg(error.message || 'Could not update the password.'); return }
    setMsg('Password updated — welcome back!', true)
    setTimeout(() => { close(); setActivePage('play') }, 1100)
  })

  // Either signal opens it: the event (normal) or the URL flag (if the event fired before we subscribed).
  supabase.auth.onAuthStateChange((event) => { if (event === 'PASSWORD_RECOVERY') open() })
  if (cameFromRecoveryLink) open()
}
